/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Chat
 */
export interface Chat {
    /**
     * Unique identifier for the chat
     * @type {string}
     * @memberof Chat
     */
    readonly id: string;
    /**
     * Thread ID for the chat conversation
     * @type {string}
     * @memberof Chat
     */
    threadId: string;
    /**
     * Title of the chat conversation
     * @type {string}
     * @memberof Chat
     */
    title: string;
    /**
     * Timestamp when the chat was created
     * @type {Date}
     * @memberof Chat
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the chat was last updated
     * @type {Date}
     * @memberof Chat
     */
    readonly updatedAt: Date;
    /**
     * ID of the account that owns this chat
     * @type {string}
     * @memberof Chat
     */
    readonly accountId: string;
    /**
     * ID of the associated itinerary (if any)
     * @type {string}
     * @memberof Chat
     */
    readonly itineraryId: string | null;
}

/**
 * Check if a given object implements the Chat interface.
 */
export function instanceOfChat(value: object): value is Chat {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('threadId' in value) || value['threadId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('itineraryId' in value) || value['itineraryId'] === undefined) return false;
    return true;
}

export function ChatFromJSON(json: any): Chat {
    return ChatFromJSONTyped(json, false);
}

export function ChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): Chat {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'threadId': json['threadId'],
        'title': json['title'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'accountId': json['accountId'],
        'itineraryId': json['itineraryId'],
    };
}

  export function ChatToJSON(json: any): Chat {
      return ChatToJSONTyped(json, false);
  }

  export function ChatToJSONTyped(value?: Omit<Chat, 'id'|'createdAt'|'updatedAt'|'accountId'|'itineraryId'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threadId': value['threadId'],
        'title': value['title'],
    };
}

